module.exports = __webpack_public_path__ + "static/media/cash-cheque-deposit.76699dbb.png";